module.exports = __webpack_public_path__ + "images/videoCaseStudy-challenge-fbMock.png?h=f5b53df7bc81ece9caf7cd989b2f0160";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/videoCaseStudy-challenge-fbMock.png
// module id = 1604
// module chunks = 12 15